import { useEffect, useState } from "react";
import { siteConfig } from "@/mocks/chiGuaData";

const navLinks = [
  { href: "#hot", label: "热门瓜榜" },
  { href: "#fresh", label: "今日新鲜" },
  { href: "#browse", label: "分类浏览" },
  { href: "#guide", label: "冲浪指南" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur shadow-[0_1px_0_rgba(0,0,0,0.04)]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-18 items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="吃瓜网上 首页"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50 ${
              solid ? "" : "ring-2 ring-background-50/40"
            }`}
          >
            <i className="ri-chat-smile-fill" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            {siteConfig.brand}
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors hover:bg-primary-500/10 hover:text-primary-600 ${
                solid ? "text-foreground-700" : "text-background-50/90 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#fresh"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始刷瓜
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
            solid ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-3 text-base text-foreground-800 hover:bg-primary-500/10 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#fresh"
            onClick={() => setOpen(false)}
            className="mt-3 block rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-semibold text-background-50"
          >
            开始刷瓜
          </a>
        </div>
      )}
    </header>
  );
}